import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import * as Sentry from "@sentry/browser";
import { GoogleOAuthProvider } from '@react-oauth/google'



Sentry.init({
  dsn: import.meta.env.VITE_GLITCHTIP_DSN,
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_APP_RELEASE,
  tunnel:
    "/monitoring/sentry"
  ,
  allowUrls: ["https://digestr.ai"],
  tracesSampleRate: 0.0,
});


const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>

      <App />
    </GoogleOAuthProvider>

  </React.StrictMode>,
)